import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import type { State } from 'state';
import { getFormName, getFormInstructions, getIconUrl } from 'state/selectors/request-create';
import { PaperHeader } from 'view/common/paper-header';

interface ExternalProps {
    requestTypeId: number | undefined;
    portalId: number | undefined;
}

const getRequestTypeName = (state: State, props: ExternalProps): string | undefined => {
    const { portalId, requestTypeId } = props;
    return portalId && requestTypeId ? getFormName(state, portalId, requestTypeId) : undefined;
};

const getRequestTypeInstructions = (state: State, props: ExternalProps): string | undefined => {
    const { portalId, requestTypeId } = props;
    return portalId && requestTypeId ? getFormInstructions(state, portalId, requestTypeId) : undefined;
};

const getLogoUrl = (state: State, props: ExternalProps): string | undefined => {
    const { portalId, requestTypeId } = props;
    return portalId && requestTypeId ? getIconUrl(state, portalId, requestTypeId) : undefined;
};

const selector = createSelector(
    getRequestTypeName,
    getRequestTypeInstructions,
    getLogoUrl,
    (requestTypeName, requestTypeInstructions, logoUrl) => ({
        logoUrl,
        subHeading: requestTypeName,
        description: requestTypeInstructions,
        dangerouslyAllowHtmlInDescription: true,
    })
);

export default connect(selector)(PaperHeader);
